var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [(_vm.showcreatedthconfig == false) ? _c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  }, [_vm._v("   Hub Delivery")])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("AWB")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWB),
      expression: "AWB"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "txt",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "awb",
      "id": "awb",
      "placeholder": "Enter upto 20 AWB No"
    },
    domProps: {
      "value": (_vm.AWB)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onPageChange(1, $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWB = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Client Short/ Display Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.companyNamelist,
      "name": "CompanyList",
      "placeholder": "Select Client",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.ClientName),
      callback: function($$v) {
        _vm.ClientName = $$v
      },
      expression: "ClientName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Destination Hub ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-list'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.hubaccessObjArray,
      "name": "hub",
      "placeholder": "Select  Hub",
      "label": "hubname",
      "track-by": "hubid",
      "multiple": false,
      "scroll": true
    },
    model: {
      value: (_vm.hubids),
      callback: function($$v) {
        _vm.hubids = $$v
      },
      expression: "hubids"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Appointment Date Range")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o' style='font-size: 12px'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "shortcuts": _vm.shortcuts,
      "lang": "en",
      "name": "appointmentDate",
      "format": "DD-MM-YYYY"
    },
    on: {
      "change": function($event) {
        _vm.allowedappointmentDates($event)
      }
    },
    model: {
      value: (_vm.appointmentDate),
      callback: function($$v) {
        _vm.appointmentDate = $$v
      },
      expression: "appointmentDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Hub Inscan Date Range")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o' style='font-size: 12px'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "shortcuts": _vm.shortcuts,
      "lang": "en",
      "name": "currenthubinscandate",
      "format": "DD-MM-YYYY",
      "not-after": _vm.disabledHubInscandate
    },
    on: {
      "change": function($event) {
        _vm.allowedinScanDates($event)
      }
    },
    model: {
      value: (_vm.currenthubinscandate),
      callback: function($$v) {
        _vm.currenthubinscandate = $$v
      },
      expression: "currenthubinscandate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onPageChange(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n\t\t\t\t\t\t\t\t"), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])])])])], 1)], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" HubToDeliver Waybills")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b', {
    staticStyle: {
      "float": "right",
      "color": "black"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.DownloadHTDData
    }
  }, [_vm._v("Download .XLSX")])])]), _vm._v(" "), (_vm.selectedAWB.length > 0) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "5px 0px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "css-246joi engpuj80"
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.selectedAWB.length) + " "), (_vm.selectedAWB.length == 1) ? _c('span', [_vm._v(" shipment ")]) : _c('span', [_vm._v(" shipments")])]), _vm._v(" selected in total.")]), _vm._v(" "), _c('button', {
    staticClass: "css-d79wd3",
    attrs: {
      "aria-busy": "false",
      "tabindex": "0",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "css-178ag6o",
    on: {
      "click": function($event) {
        _vm.removeHTD(_vm.selectedAWB, 1)
      }
    }
  }, [_c('span', [_vm._v("Remove HTD")])])]), _vm._v(" "), _c('div', {
    staticClass: "css-1q0nn2j engpuj81"
  }, [_c('button', {
    staticClass: "css-hv8rsi",
    attrs: {
      "aria-busy": "false",
      "tabindex": "0",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "css-178ag6o",
    on: {
      "click": function($event) {
        _vm.unselectHTDShipment(_vm.selectedAWB)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#6B778C"
    }
  }, [_vm._v("Cancel")])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isAllSelected),
      expression: "isAllSelected"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isAllSelected) ? _vm._i(_vm.isAllSelected, null) > -1 : (_vm.isAllSelected)
    },
    on: {
      "click": _vm.selectAll,
      "__c": function($event) {
        var $$a = _vm.isAllSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isAllSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isAllSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isAllSelected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr enabled"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("MPS")]), _vm._v(" "), _c('th', [_vm._v("Client Ref. No.")]), _vm._v(" "), _c('th', [_vm._v("Route Mode")]), _vm._v(" "), _c('th', [_vm._v("Booking Mode")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Origin")]), _vm._v(" "), _c('th', [_vm._v("Destination")]), _vm._v(" "), _c('th', [_vm._v("Phy Wt(KG) ")]), _vm._v(" "), _c('th', [_vm._v("Vol Wt(KG)")]), _vm._v(" "), _c('th', [_vm._v("PDD Date")]), _vm._v(" "), _c('th', [_vm._v("Hub Inscan Date")]), _vm._v(" "), _c('th', [_vm._v("Appointment Date ")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.tableItems), function(data) {
    return [_c('tr', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedAWB),
        expression: "selectedAWB"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.selectedAWB) ? _vm._i(_vm.selectedAWB, data) > -1 : (_vm.selectedAWB)
      },
      on: {
        "click": _vm.select,
        "__c": function($event) {
          var $$a = _vm.selectedAWB,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedAWB = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedAWB = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedAWB = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr"
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": "warn_info"
      }
    }, [_vm._v(_vm._s(data.AWB))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.MPS))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ClientRefNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.RouteMode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.BookingMode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Origin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Destination))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.PhyWt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.VolWt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.PDDDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CurrentHubinscandate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.AppointmentDate))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "markhtd"
    }, [_c('u', {
      staticClass: "action",
      attrs: {
        "title": "Remove HTD"
      },
      on: {
        "click": function($event) {
          _vm.removeHTD(data, 2)
        }
      }
    }, [_vm._v("Remove HTD")])])])])]
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "no-close-on-esc": true,
      "no-close-on-backdrop": true,
      "hide-header-close": true
    },
    on: {
      "ok": function($event) {
        _vm.removehtdModal = false
      }
    },
    model: {
      value: (_vm.removehtdModal),
      callback: function($$v) {
        _vm.removehtdModal = $$v
      },
      expression: "removehtdModal"
    }
  }, [_c('b-card', {
    staticClass: "overflow-hidden"
  }, [_c('div', {
    staticStyle: {
      "color": "black"
    },
    slot: "header"
  }, [_vm._v("\n\t  Remove HTD\n\t   "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeremovehtd
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text",
    staticStyle: {
      "color": "red",
      "font-size": "14px"
    },
    attrs: {
      "id": "removenote",
      "name": "removenote"
    }
  }, [_vm._v("Note*: Selected Shipments removed from the list.")]), _vm._v(" "), (_vm.promiseAwbList.length > 0) ? _c('div', [_c('div', {
    staticClass: "progress-container",
    class: [!_vm.Promiseinprogress ? 'progress-bar-complete' : '']
  }, [_c('div', {
    staticClass: "progress-bar",
    class: [_vm.Promiseinprogress ? 'progress-bar-animation' : 'progress-bar-complete']
  }, [_c('div', {
    staticClass: "js-completed-bar completed-bar",
    attrs: {
      "data-complete": "60"
    }
  }, [_c('hr', {
    staticClass: "completed-bar__dashed"
  })])])]), _vm._v(" "), _vm._l((_vm.promiseAwbList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "selecteditem"
    }, [_c('div', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(" " + _vm._s(_vm.promiseresultstatus[index].status))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "45%"
      }
    }, [_vm._v(" " + _vm._s(_vm.promiseresultstatus[index].message))])])
  })], 2) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-000d8644","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/htdawblevelmarking/htdwaybills/htdwaybills.component.html
// module id = 1976
// module chunks = 3